import * as React from "react";
import { Box, Typography } from "@mui/material";
import TrainerEntryDataGrid from "../../sessions/sessionDetail/payroll/trainerEntryDetail/trainerEntryDataGrid";

export type PayrollProjectFacultyDetailsProps = {
    projectCode: string;
    sessionId: string;
    workEntryData?: any;
};

const PayrollProjectFacultyDetails: React.FC<PayrollProjectFacultyDetailsProps> = (props) => (
    <Box sx={{ width: 1, height: 1, p: 1 }}>
        {props.workEntryData ? (
            <TrainerEntryDataGrid
                projectCode={props.projectCode}
                sessionId={props.sessionId}
                workEntryData={props.workEntryData}
            />
        ) : (
            <Typography color="text.secondary">
                Select a work entry and choose View Faculty Details to see its faculty entries.
            </Typography>
        )}
    </Box>
);

export default PayrollProjectFacultyDetails;